import { render } from "./SitebarNavigation.vue?vue&type=template&id=d49db614"
import script from "./SitebarNavigation.vue?vue&type=script&lang=ts"
export * from "./SitebarNavigation.vue?vue&type=script&lang=ts"

import "./SitebarNavigation.vue?vue&type=style&index=0&id=d49db614&lang=scss"
script.render = render

export default script